import CartItem from './CartItem';

const PAYMENT_METHODS = [
  { value:'cash', label:'💵 Готівка' },
  { value:'card', label:'💳 Картка' },
  { value:'mixed', label:'🔀 Змішана' },
];

export default function Cart({
  cart, customer, bonusToUse,
  paymentMethod, onPaymentChange,
  onUpdate, onRemove, onClear, onSale,
  loading, error, promoDiscounts=[], totalAfterPromos,
  earnFrac=0.01, maxSpendFrac=0.3,
}) {
  const subtotal = cart.reduce((sum, i) => sum + parseFloat(i.price) * i.quantity, 0);
  const base = totalAfterPromos !== undefined ? totalAfterPromos : subtotal;
  const promoSave = Math.round((subtotal - base) * 100) / 100; // знижка за акціями
  const bonusDiscount = Math.min(
    parseFloat(bonusToUse) || 0,
    customer ? parseFloat(customer.bonus_balance) : 0,
    base * maxSpendFrac
  );
  const total = base - bonusDiscount;
  const bonusEarned = customer && !customer.is_blacklisted
    ? Math.round(total * earnFrac * 100) / 100
    : 0;

  if (cart.length === 0) return (
    <div style={styles.empty}>
      <div style={{fontSize:'48px', marginBottom:'8px'}}>🛒</div>
      <p style={{color:'#9a8a6e', fontSize:'14px'}}>Оберіть товари зліва</p>
    </div>
  );

  return (
    <div style={styles.wrap}>
      {/* Прокручувані позиції */}
      <div style={styles.items}>
        {cart.map(item => (
          <CartItem
            key={item.cartKey}
            item={item}
            onUpdate={onUpdate}
            onRemove={onRemove}
          />
        ))}
      </div>

      {/* Фіксований підсумок внизу */}
      <div style={styles.summary}>
        <div style={styles.line}>
          <span style={styles.lineLabel}>Сума ({cart.length} поз.)</span>
          <span>{subtotal.toFixed(2)} ₴</span>
        </div>
        {promoSave > 0 && (promoDiscounts.length ? promoDiscounts : [{ name: 'Акції', save: promoSave }]).map((p, i) => (
          <div key={i} style={styles.line}>
            <span style={{color:'#5fbf8f'}}>🎁 {p.name}</span>
            <span style={{color:'#5fbf8f'}}>−{parseFloat(p.save).toFixed(2)} ₴</span>
          </div>
        ))}
        {bonusDiscount > 0 && (
          <div style={styles.line}>
            <span style={{color:'#ff6b6b'}}>🎁 Знижка бонусами</span>
            <span style={{color:'#ff6b6b'}}>−{bonusDiscount.toFixed(2)} ₴</span>
          </div>
        )}
        <div style={styles.totalLine}>
          <span>До оплати</span>
          <span style={{color:'#f5a623'}}>{total.toFixed(2)} ₴</span>
        </div>
        {bonusEarned > 0 && (
          <div style={styles.bonusEarned}>
            🎁 Нараховується {bonusEarned.toFixed(2)} бонусів
          </div>
        )}

        <div style={styles.paymentRow}>
          {PAYMENT_METHODS.map(pm => (
            <button
              key={pm.value}
              style={paymentMethod === pm.value ? styles.pmActive : styles.pm}
              onClick={() => onPaymentChange(pm.value)}>
              {pm.label}
            </button>
          ))}
        </div>

        {error && <div style={styles.error}>{error}</div>}

        <button
          style={{...styles.saleBtn, ...(loading ? styles.saleBtnLoading : {})}}
          onClick={() => onSale(bonusDiscount, total)}
          disabled={loading}>
          {loading ? '⟳ Обробка...' : `✓ Продати ${total.toFixed(2)} ₴`}
        </button>

        <button style={styles.clearBtn} onClick={onClear}>
          Очистити кошик
        </button>
      </div>
    </div>
  );
}

const styles = {
  wrap: {
    display:'flex',
    flexDirection:'column',
    flex:1,          // займає весь вільний простір у панелі кошика
    minHeight:0,     // ← дозволяє внутрішньому списку скролитись
    overflow:'hidden', // ← ключове
  },
  empty: {
    flex:1,
    display:'flex',
    flexDirection:'column',
    alignItems:'center',
    justifyContent:'center',
  },
  items: {
    flex:1,          // займає весь вільний простір
    overflowY:'auto', // прокручується
    padding:'8px 12px',
    minHeight:0,     // ← без цього flex не обрізає контент
  },
  summary: {
    flexShrink:0,    // ніколи не стискається
    padding:'10px 12px',
    borderTop:'1px solid #38301f',
    background:'#14110c',
  },
  line: { display:'flex', justifyContent:'space-between', fontSize:'13px', color:'#9a8a6e', marginBottom:'3px' },
  lineLabel: { color:'#9a8a6e' },
  totalLine: { display:'flex', justifyContent:'space-between', fontSize:'20px', fontWeight:'bold', padding:'6px 0', borderTop:'1px solid #38301f', marginTop:'3px' },
  bonusEarned: { color:'#5fbf8f', fontSize:'12px', textAlign:'center', marginBottom:'8px', background:'#0d2818', padding:'5px', borderRadius:'6px' },
  paymentRow: { display:'flex', gap:'5px', marginBottom:'8px' },
  pm: { flex:1, padding:'7px 3px', background:'#38301f', color:'#9a8a6e', border:'none', borderRadius:'7px', cursor:'pointer', fontSize:'11px' },
  pmActive: { flex:1, padding:'7px 3px', background:'#1c1812', color:'#f5a623', border:'1px solid #f5a623', borderRadius:'7px', cursor:'pointer', fontSize:'11px', fontWeight:'bold' },
  error: { color:'#ff6b6b', fontSize:'12px', textAlign:'center', marginBottom:'6px', background:'#3d0000', padding:'5px', borderRadius:'6px' },
  saleBtn: { width:'100%', padding:'13px', background:'#2d6a4f', color:'#5fbf8f', border:'none', borderRadius:'10px', fontSize:'15px', fontWeight:'bold', cursor:'pointer', marginBottom:'6px' },
  saleBtnLoading: { opacity:0.6, cursor:'not-allowed' },
  clearBtn: { width:'100%', padding:'7px', background:'transparent', color:'#9a8a6e', border:'1px solid #38301f', borderRadius:'8px', cursor:'pointer', fontSize:'12px' },
};
